
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2012_4377)"}},[_c('circle',{attrs:{"cx":"32","cy":"32.061","r":"22","fill":"#74DBB5"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.039.15c17.646 0 31.95 14.303 31.95 31.95 0 17.646-14.306 31.95-31.95 31.95C14.392 64.05.089 49.744.089 32.1.089 14.453 14.392.15 32.039.15zm0 30.107c12.192 0 12.768 16.601 1.728 18.17v1.761c0 2.285-3.455 2.287-3.455 0v-1.79c-4.375-.756-8-4.33-8-8.996 0-2.424 3.684-2.424 3.684 0 0 3.252 2.952 5.457 6.043 5.457 7.958 0 7.958-10.917 0-10.917-12.192 0-12.768-16.6-1.727-18.17v-1.76c0-2.287 3.455-2.285 3.455 0v1.79c4.376.756 8.002 4.33 8.002 8.994 0 2.425-3.688 2.425-3.688 0 0-3.253-2.952-5.457-6.042-5.457-7.958 0-7.958 10.916 0 10.916v.002z","fill":"#1E1E1E"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2012_4377"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .061)","d":"M0 0h64v64H0z"}})])])])
          )
        }
      }
    